module.exports = __webpack_public_path__ + "static/media/elk_water_testing_map_bg.56f53fb7.jpg";